import React from 'react';
import Main from "./components/Main";
import Section from "./components/Section";
import { getErrorMessage, getFirebaseErrorCode, isFirebaseError } from "./utils/errorUtils";
import { Container } from 'react-bootstrap';
import LogRocket from 'logrocket';

function isSessionStorageAvailable() {
    try {
        const testKey = '__storage_test__';
        sessionStorage.setItem(testKey, 'test');
        sessionStorage.removeItem(testKey);
        return true;
    } catch {
        return false;
    }
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        // You can also log error messages to an error reporting service here
        console.log(error);
        console.log(errorInfo);

        LogRocket.captureException(error);
        LogRocket.captureMessage(errorInfo.componentStack);
    }

    render() {
        if (this.state.errorInfo) {
            // Error path
            if (isFirebaseError(this.state.error) && getFirebaseErrorCode(this.state.error) === 'permission-denied') {
                return (
                    <Main>
                        <Container>
                            <Section title="No Access">
                                <h4>Sorry, but you don't have the permissions necessary to access this page. If you believe you are receiving this in error, please contact customer support.</h4>
                            </Section>
                        </Container>
                    </Main>
                );
            } else if (this.state.error?.name === 'ChunkLoadError') {
                const storageAvailable = isSessionStorageAvailable();
                const hasReloaded = storageAvailable && sessionStorage.getItem('chunkErrorReload');
                if (!hasReloaded && storageAvailable) {
                    sessionStorage.setItem('chunkErrorReload', 'true');
                    window.location.reload();
                    return null;
                }

                return (
                    <Main>
                        <Container>
                            <Section title="We have some exciting new updates!">
                                <p>We have some exciting new updates that have been released since the last time you refreshed your browser!</p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => {
                                        if (storageAvailable) sessionStorage.removeItem('chunkErrorReload');
                                        window.location.reload();
                                    }}
                                >
                                    Refresh Now
                                </button>
                            </Section>
                        </Container>
                    </Main>
                );
            } else {
                return (
                    <Main>
                        <Container>
                            <Section title="Something went wrong.">
                                <p>{getErrorMessage(this.state.error)} Please refresh your browser and try again.</p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => window.location.reload()}
                                >
                                    Refresh Now
                                </button>
                            </Section>
                        </Container>
                    </Main>
                );
            }
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;